import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { compose } from 'redux'
import styles from './navItem.module.scss'
import withRouter from '../../../hooks/withRouter'
import { RootState } from '../../../redux/store'
import { NavItem as NavItemType } from '../../../types/navItem'

interface NavItemProps {
  title: string
  to: string
  items: NavItemType[]
}

const NavItem = (props: NavItemProps) => {
  const { title, to, items } = props

  return (
    <div className={styles.container}>
      <NavLink to={to} className={styles.title}>
        {title}
      </NavLink>
      <div className={styles.triangle}></div>
      <div className={styles.itemsContainer}>
        {items &&
          items.map((item: NavItemType) => {
            return (
              <NavLink
                to={`/books/categories${item.to}`}
                className={styles.item}
                key={item.name}
              >
                <div className={styles.itemContainer}>
                  <i className="fas fa-arrow-right"></i>
                  {item.name}
                </div>
              </NavLink>
            )
          })}
      </div>
    </div>
  )
}

let mapStateToProps = (state: RootState) => {
  return {}
}

export default compose(connect(mapStateToProps, {}), withRouter)(NavItem)
